
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyAppbar as SkyAppbarElement } from '@sky.ui/core/sky-appbar';
 
 
 
 

 
 export const SkyAppbar = createComponent({
   displayName: 'SkyAppbar',
   react: React,
   tagName: 'sky-appbar',
   elementClass: SkyAppbarElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-appbar';
